import settings from '@/settings'

const get = () => {
  return fetch(`${settings.apetrusApi}/tipospagamento/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default'
  })
}

export default {
  get
}
